<template>
    <link-input :value="p_value"
				input-readonly

                :type="type"
                :color="color"
                :size="size"
                :shape="shape"
                :dashed="dashed"
                :long="long"
                :prefixIcon="prefixIcon"
                :suffix-icon="suffixIcon"
                :disabled="lv_disabled"
                :placeholder="placeholder"
                :hide-clear-icon="hideClearIcon"
                :clear-on-click-delete-icon="false"
                :required="required"
                :validate-on-init="validateOnInit"
                :rules="rules"
                @click-suffix-icon="!lv_disabled&&!lv_readonly && pl_clear()"
                @click="!lv_disabled&&!lv_readonly && pl_click()"
    />
</template>

<script>
    import {EditMixin} from "../mixins";

    export default {
        name: "link-textarea-input",
        mixins: [EditMixin],
        props: {
            value: {},

            type: {type: String, default: 'line',},
            color: {type: String, default: 'info',},
            size: {type: String, default: 'default',},
            shape: {type: String, default: 'none',},
            dashed: {type: Boolean,},
            long: {type: Boolean,},
            prefixIcon: {type: String},
            suffixIcon: {type: String, default: 'link-icon-edit'},
            placeholder: {type: String, default: ''},
            width: {},
            hideClearIcon: {type: Boolean},
            required: {type: Boolean},
            rules: {type: Array | String},
            validateOnInit: {type: Boolean,},
		  	maxlength: Number,
		  	showWordLimit: Boolean,
        },
        watch: {
            value: {
                immediate: true,
                handler(val) {
                    this.p_value = val
                },
            }
        },
        data() {
            return {
                p_value: null,
            }
        },
        methods: {
            pl_clear() {
                this.p_value = null
                this.$emit('input', null)
            },
            pl_click() {
                this.$dialog.show({
                    editType: 'textarea',
                    editValue: this.p_value,
                    confirmButton: true,
                    cancelButton: true,
                  	maxlength: this.maxlength,
				  	showWordLimit: this.showWordLimit,
                    onConfirm: (val) => {
                        this.p_value = val
                        this.$emit('input', val)
                    }
                })
            },
        }
    }
</script>

<style lang="scss">

</style>
